<template>
    <fieldset>
      <div class="form-wrap">

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Name</label>
          <input
            id="name"
            type="text"
            v-model="$parent.airline.name"
            style="height:37.6px;"
          />
        </div>
        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Airline Code</label>
          <input
            id="name"
            type="text"
            v-model="$parent.airline.airline_code"
            style="height:37.6px;"
          />
        </div>
        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Contact name</label>
          <input
            id="name"
            type="text"
            v-model="$parent.airline.contact_name"
            placeholder="Contact name"
            style="height:37.6px;"
          />
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Allowed web checkin before (days)</label>
          <input
            id="name"
            type="number"
            v-model="$parent.airline.web_check_in_before_days"
            style="height:37.6px;"
          />
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Check-in instruction document</label>
          <input id="file-upload" type="file" class="form-control" @change="uploadDoc" accept=".pdf">
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);" v-if="$parent.airline.instruction_doc_name">
          <label>Check-in instruction document</label>
          <div class="mt-3"><a href="javascript:void(0);" v-on:click="documentDownload($parent.airline.id, $parent.airline.instruction_doc_name)"><b>{{$parent.airline.instruction_doc_name}}</b></a></div>
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(50% - 1rem);">
          <label for="checkin_video_desktop_url">Desktop Check-in Video URL</label>
          <input
            id="checkin_video_desktop_url"
            type="url"
            class="form-control"
            v-model="$parent.airline.checkin_video_desktop_url"
            placeholder="https://..."
          />

          <label for="checkin_video_mobile_url" style="margin-top: 1rem;">
            Mobile Check-in Video URL
          </label>
          <input
            id="checkin_video_mobile_url"
            type="url"
            class="form-control"
            v-model="$parent.airline.checkin_video_mobile_url"
          placeholder="https://..."
          />
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(50% - 1rem);">
          <label for="airline_content">Airline Content</label>
          <textarea id="airline_content" style="max-width: 100%; min-height: 8rem" v-model="$parent.airline.airline_content"></textarea>
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Airline We url</label>
          <input
            id="name"
            type="text"
            v-model="$parent.airline.web_url"
            placeholder="Web Url"
            style="height:37.6px;"
          />
        </div>

        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Airline Code for Flight Times</label>
          <input
            id="name"
            type="text"
            v-model="$parent.airline.flight_times_code"
            placeholder="Airline Flight Time Code"
            style="height:37.6px;"
          />
        </div>
        
        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(25% - 1rem);">
          <label for="name">Airline Code for Flight Budget</label>
          <input
            id="name"
            type="text"
            v-model="$parent.airline.flight_budget_code"
            placeholder="Airline Flight Budget Code"
            style="height:37.6px;"
          />
        </div>
        
      </div>

    </fieldset>
</template>

<script>
  export default {
    name: 'AirlineFields',
    data () {
      return {
      }
    },
    methods:{
      uploadDoc(event) {
        this.$parent.airline.instruction_doc = event.target.files[0];
      },
      documentDownload(id, filename) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'airlines/airline-instruction/' + id + '/download' , {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then((res) => {
          if(res.status === 200) {
            res.blob().then(response => {
              const _url = window.URL.createObjectURL(response)
              const link = document.createElement('a')
              link.href = _url
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click();
            })
          }else {
            this.$notify({
              type: 'error',
              title: 'File not found'
            });
          }
        })
        this.$store.dispatch('setLoadStatus')
      }
    }
  }
</script>
